<div
  class="profile-overview-configuration"
  id="profile-overview-configuration-page"
>
  <ptg-breadcrumb
    [listBreadcrumbs]="listBreadcrumbs"
    (onAdd)="addProfileConfig()"
    buttonAddLabel="New View"
  ></ptg-breadcrumb>

  <div *ngIf="bannerType" class="p-6">
    <ptg-banner [(bannerType)]="bannerType" [message]="message"></ptg-banner>
  </div>

  <ptg-grid
    [data]="profileOverviewsData"
    [columns]="columns"
    [isLoading]="isLoading"
    [paginable]="false"
    (sortChange)="sortChange($event)"
    [errorMessage]="errorMsg"
    [fitToParent]="true"
    notFoundMessage="No Profile Overview View to Display"
  >
    <ng-template cellContent columnName="statuses" let-row>
      <ptg-list-status [statusList]="row.statuses"></ptg-list-status>
    </ng-template>
    <ng-template cellContent columnName="action" let-row>
      <ptg-button
        buttonName="Edit"
        classInput="edit-button"
        (clickButton)="editRecord(row)"
      >
        <mat-icon>edit</mat-icon>
      </ptg-button>
      <ptg-button
        *ngIf="!row.isStatic"
        buttonName="Remove"
        classInput="remove-button"
        (clickButton)="removeRecord(row)"
      >
        <mat-icon>delete_forever</mat-icon>
      </ptg-button>
    </ng-template>
  </ptg-grid>
</div>
